import createComponent from 'styles/fela/createComponent';
import ButtonWithSpinner from './ButtonWithSpinner';

const BasicButton = createComponent(({
  theme,
  minWidth,
  size,
  fixedWidth,
  withWidth,
  fullWidth,
  disabled,
  nowrap,
  lineHeight,
}) => ({
  border: '0 none',
  borderRadius: theme.radius.default,
  textAlign: 'center',
  userSelect: 'none',
  cursor: 'pointer',
  display: 'flex',
  width: 'auto',
  minWidth: theme.size.fixedWidthButton,
  height: '3.5rem',
  lineHeight: 1.2,
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  paddingLeft: theme.margin.large,
  paddingRight: theme.margin.large,
  textDecoration: 'none',

  '&[disabled]': {
    color: theme.color.disabled,
  },

  extend: [
    {
      condition: minWidth,
      style: {
        minWidth,
      },
    },
    {
      condition: size === 'medium',
      style: {
        height: '2rem',
        lineHeight: '2rem',
        textTransform: 'capitalize',
      },
    },
    {
      condition: withWidth || fixedWidth,
      style: {
        minWidth: 'auto',
        width: withWidth || theme.size.fixedWidthButton,
      },
    },
    {
      condition: fullWidth,
      style: {
        width: '100%',
      },
    },
    {
      condition: disabled,
      style: {
        cursor: 'not-allowed',
      },
    },
    {
      condition: nowrap,
      style: {
        whiteSpace: 'nowrap',
      },
    },
    {
      condition: lineHeight,
      style: {
        lineHeight,
      },
    },
  ],
}), ButtonWithSpinner, ['minWidth', 'size', 'fixedWidth', 'withWidth', 'fullWidth', 'nowrap', 'lineHeight']);

export default BasicButton;
